function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var _excluded = ["type", "placeholder", "className", "inputClassName", "id", "variant", "label", "error", "leftIcon", "rightIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
import React from 'react';
import cn from 'classnames';
import './Input.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Input = /*#__PURE__*/ React.forwardRef(function (_ref, ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, placeholder = _ref.placeholder, className = _ref.className, inputClassName = _ref.inputClassName, id = _ref.id, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? 'default' : _ref$variant, label = _ref.label, error = _ref.error, leftIcon = _ref.leftIcon, rightIcon = _ref.rightIcon, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('custom-input', {
            'custom-input--search': variant === 'search',
            'custom-input--default': variant === 'default',
            'custom-input--error': !!error
        }, className),
        children: [label && /*#__PURE__*/ _jsx("label", {
                className: "custom-input__label",
                htmlFor: id,
                children: label
            }), /*#__PURE__*/ _jsxs("div", {
                className: "custom-input__inner",
                children: [leftIcon && /*#__PURE__*/ _jsx("span", {
                        className: cn('custom-input__icon custom-input__icon--left', {
                            'custom-input__icon--error': !!error
                        }),
                        children: leftIcon
                    }), /*#__PURE__*/ _jsx("input", _objectSpread({
                        ref: ref,
                        className: cn('input', {
                            'input--error': !!error,
                            'input--with-left-icon': !!leftIcon,
                            'input--with-right-icon': !!rightIcon
                        }, inputClassName),
                        type: type,
                        placeholder: placeholder,
                        id: id,
                        "aria-invalid": !!error
                    }, props)), rightIcon && /*#__PURE__*/ _jsx("span", {
                        className: "custom-input__icon custom-input__icon--right",
                        children: rightIcon
                    })]
            }), error && /*#__PURE__*/ _jsx("span", {
                className: "custom-input__error",
                children: error
            })]
    });
});
Input.displayName = 'Input';
export default Input;
